import { Label } from "reactstrap";
import { useState } from "react";

// Make SelectInput generic for any form data type

interface SelectInputProps<T> {
  formData: T;
  setFormData: (data: T) => void;
  label: string;
  id: keyof T;
  options: string[];
  disabled?: boolean;
  htmlId?: string; // Optional HTML id for styling purposes
  containerClassName?: string;
}

function SelectInput<T>({ formData, setFormData, label, id, options, disabled = false, htmlId, containerClassName = 'mb-3' }: SelectInputProps<T>) {
  const selectedValue = (formData[id] as string) || '';
  const elementId = htmlId || String(id);

  return (
    <div className={containerClassName}>
      <Label htmlFor={elementId} className="form-label mb-0">
        {label}
      </Label>
      <select
        className="form-select form-select-sm w-full"
        id={elementId}
        aria-label={label}
        value={selectedValue}
        onChange={e => setFormData({ ...formData, [id]: e.target.value })}
        disabled={disabled}
      >
        <option value="" disabled>
          {disabled ? `Select ${label.toLowerCase().replace('sub', '').trim()} first` : 'Select...'}
        </option>
        {options.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectInput;
